import { PumoModuleFragment } from '../../generated/types';
import { useSwitchAmexModules } from './useSwitchAmexModules';

export const useProcessModules = (modules: PumoModuleFragment[]) => {
  return useSwitchAmexModules(modules);
};
